import _ from "lodash";

import { Api } from "@api/index";
import { ModelSelectStateProps, ModelSelectOuterProps, makeModelSelectComponent } from "@api/components/ModelSelect";
import { AuthState } from "@auth/models";
import { FilesState } from "@files/models";
import { Album, MusicState } from "../../models";
import { makeHydrateAlbum, makeGetAlbums } from "../../selectors";
import { NormalisedEntities } from "@app/modules/orm/models";

type State = MusicState & FilesState & AuthState;

const makeMapStateToProps = () => {
    const getAlbums = makeGetAlbums();
    return (state: State, props: ModelSelectOuterProps<Album>) => {
        const albumProps = {
            albums: [] as Album[],
        };
        if (Array.isArray(props.selected)) {
            albumProps.albums = _.map(props.selected, (id: number) => new Album({id}));
        }
        else if (props.selected != null) {
            albumProps.albums = [new Album({id: props.selected})];
        }
        return {
            selectedModels: getAlbums(state, albumProps),
        } as ModelSelectStateProps<Album>;
    };
};

const { presenter, connected } = makeModelSelectComponent<Album, State>(
    "album-select",
    ({ id }: Album) => String(id),
    (album: Album) => album.artistsStr
        + " - " + album.title
        + (album.upc ? " (" + album.upc + ")" : ""),
    Api.albumsSearch,
    (entities: NormalisedEntities) => makeHydrateAlbum(entities, entities, entities),
    makeMapStateToProps,
);

export {
    presenter as AlbumSelectPresenter,
    connected as AlbumSelect,
};
